var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _vm.proposal.actions.supplier?.contract === "sign"
        ? _c(
            "b-btn",
            {
              staticClass: "btn-card-action btn-card-action-danger my-1",
              attrs: {
                to: {
                  name: "CommercialPurchaseShow",
                  params: { id: _vm.proposal.purchase.id },
                  hash: "#atmo-contract",
                },
                target: "_blank",
              },
            },
            [_vm._v("Подписать договор")]
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }